var render, staticRenderFns
import script from "./CertificateList.vue?vue&type=script&lang=js&"
export * from "./CertificateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbc5d49a')) {
      api.createRecord('bbc5d49a', component.options)
    } else {
      api.reload('bbc5d49a', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Certificate/resources/vue/CertificateList.vue"
export default component.exports